import React, { Component } from 'react';

class IconSidebarItemRemark extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
            >
                <g fill={this.props.isActive ? "#26A" : "#424242"} clipPath="url(#clip0_9734_3206)">
                    <path d="M18.455 12.565a.762.762 0 00-.363-.564.724.724 0 00-.631-.044c-.208.081-.46.29-.46.794v1.492c0 1.515 0 3.09.007 4.633 0 .208-.06.38-.17.498-.112.111-.282.17-.483.17-2.693-.007-5.386-.007-8.08-.007H5.137c-.468 0-.66-.193-.66-.66V6.38c0-.46.2-.66.667-.66h7.502c.23 0 .445-.097.586-.275.133-.17.185-.401.133-.624-.074-.349-.37-.55-.801-.55H5.1c-.163 0-.297.008-.43.03C3.66 4.501 3 5.304 3 6.306v12.689C3 20.116 3.883 21 5.003 21h11.449c.156 0 .319-.022.467-.06.935-.23 1.536-1.01 1.543-1.982v-6.244c-.007-.052-.007-.097-.007-.149z"></path>
                    <path d="M20.993 5.393c-.008-.067-.015-.156-.03-.245-.148-1.166-1.187-2.109-2.367-2.146-.779-.03-1.424.245-1.996.817l-.809.81c-2.248 2.256-4.57 4.588-6.87 6.86-.542.534-.883 1.084-1.076 1.73-.2.676-.43 1.351-.653 2.012l-.312.913c-.118.364-.044.661.216.876a.673.673 0 00.437.156c.097 0 .208-.022.32-.06l.541-.177c1.046-.35 2.085-.69 3.124-1.047.148-.052.296-.141.408-.26 2.196-2.19 4.392-4.388 6.589-6.586l1.706-1.708c.505-.505.764-1.12.78-1.878l-.008-.067zM10.88 14.57c-.58.2-1.165.394-1.751.587l-.43.14.11-.311c.127-.357.245-.69.334-1.04.149-.586.46-1.091 1.01-1.633 1.966-1.938 3.954-3.935 5.876-5.858L17.63 4.85c.268-.267.535-.394.831-.394.082 0 .164.008.245.03.394.097.683.357.794.72.112.372.008.78-.282 1.092a57.69 57.69 0 01-.074.074l-.757.757-7.3 7.307a.75.75 0 01-.208.133z"></path>
                </g>
                <defs>
                    <clipPath id="clip0_9734_3206">
                        <path fill="#fff" d="M0 0H18V18H0z" transform="translate(3 3)"></path>
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default IconSidebarItemRemark;